import { initStorageInstance } from './index'
import {
  JIJIA_INSURANCE_REFUND_ORDER_DATA,
  THIRD_PARTY_DRONE_PINGAN2024_OPERATOR_KEY,
  JIJIA_INSURANCE_CONFIRM_ORDER_DATA,
} from './constant'

export const InsuranceJijiaOrderRefundDataStorage = initStorageInstance(
  JIJIA_INSURANCE_REFUND_ORDER_DATA,
  {
    type: 'sessionStorage',
    verifyMobile: true,
  }
)

export const InsuranceThirdPartyDronePingan2024DataStorage = initStorageInstance(
  THIRD_PARTY_DRONE_PINGAN2024_OPERATOR_KEY,
  {
    type: 'sessionStorage',
    verifyMobile: true,
  }
)

export const InsuranceJijiaConfirmInfoStorage = initStorageInstance(
  JIJIA_INSURANCE_CONFIRM_ORDER_DATA,
  {
    type: 'sessionStorage',
    verifyMobile: true,
  }
)
